import React from "react";
import { Link } from "react-router-dom";
import aboutImage from "../assets/images/solar/award.webp";
import HtmlContent, { PhotoLink } from "./HtmlContent";
import { mediaUrl, sectionBlocks, useSiteData } from "../lib/siteApi";

export default function About() {
  const data = useSiteData();
  const blocks = sectionBlocks(data.content, "about");
  const main = blocks[0] || {};
  const extras = blocks.slice(1);
  const title = main.title || "Leading Green Energy Innovators in Rwanda";
  const body = main.body || "RENERG (R) LTD is a registered private company in Rwanda, standing at the forefront of sustainable energy solutions with over 15 years of expertise in the green business sector. Our footprint extends across 12+ African countries, where we have successfully delivered more than 1.3 GW of solar projects.";
  const image = mediaUrl(main.imageUrl) || aboutImage;

  return (
    <section className="relative py-20 lg:py-28 bg-gradient-to-br from-slate-50 to-teal-50 dark:from-slate-900 dark:to-slate-800" id="about">
      <div className="absolute top-0 left-0 w-72 h-72 bg-teal-500/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500/5 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>

      <div className="container relative">
        <div className="grid lg:grid-cols-12 grid-cols-1 items-center gap-10 lg:gap-16">
          <div className="lg:col-span-6">
            <div className="relative">
              <div className="relative z-10">
                <PhotoLink to="/about" src={image} alt="RENERG LTD - Green Energy Solutions" className="w-full h-auto transform group-hover:scale-105 transition-transform duration-700" wrapClassName="rounded-2xl lg:rounded-3xl shadow-2xl shadow-teal-500/10 group" />
              </div>
              <div className="absolute -z-10 -inset-6">
                <div className="w-full h-full border-2 border-teal-500/20 rounded-3xl rotate-3"></div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="lg:ms-8">
              <div className="inline-flex items-center gap-3 px-4 py-2.5 bg-teal-500/10 border border-teal-500/20 rounded-full mb-6">
                <div className="flex items-center justify-center w-6 h-6 bg-teal-500 rounded-full">
                  <span className="text-white text-sm">★</span>
                </div>
                <span className="renerg-kicker text-teal-600 dark:text-teal-400">Who We Are</span>
              </div>

              <h2 className="renerg-section leading-tight mb-6 text-slate-800 dark:text-white">
                <Link to="/about" className="hover:text-teal-700">
                {title.includes("Green Energy") ? (
                  <>Leading <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-emerald-600">Green Energy</span> Innovators in Rwanda</>
                ) : title}
                </Link>
              </h2>

              <div className="space-y-4 mb-8 renerg-body text-slate-600 dark:text-slate-300">
                <HtmlContent html={body} imageTo="/about" />
                <Link to="/about" className="inline-flex items-center font-semibold text-teal-600 hover:text-teal-700">
                  Read the full story →
                </Link>
              </div>
            </div>
          </div>
        </div>

        {extras.length > 0 && (
          <div className="grid md:grid-cols-2 gap-6 mt-12">
            {extras.map((block) => (
              <Link key={block.id} to="/about" className="rounded-2xl bg-white dark:bg-slate-900 p-6 shadow-lg hover:shadow-xl transition block">
                {block.imageUrl ? <img src={mediaUrl(block.imageUrl)} alt="" className="mb-4 h-40 w-full rounded-xl object-cover" /> : null}
                {block.title ? <h3 className="renerg-h4 mb-2 text-slate-900 dark:text-white">{block.title}</h3> : null}
                <HtmlContent html={block.body} className="text-slate-600 dark:text-slate-300 line-clamp-4" imageTo="/about" />
                <span className="mt-3 inline-block text-sm font-semibold text-teal-700">Continue on About →</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
